import { getInsightsByIssueId, getInsightsCount } from './insights.tsx';
import { createProjectHook } from './utils.tsx';

export const useInsightsByIssueId = createProjectHook(getInsightsByIssueId);

export const useInsightsCount = createProjectHook(getInsightsCount);
